import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { useIntl } from 'react-intl';
import { selectFields, selectJobModel, selectJobTarget, selectTaskTarget } from 'store/Jobs/selectors';
import StandardDropdown from 'Common/Components/StandarDropdown';
import { Wrapper, Label } from './styled';

const getFieldLabel = (intl, key, fieldDetail) => intl.formatMessage({
  id: `model.field.${key}`,
  defaultMessage: fieldDetail.display_name || fieldDetail.displayName || fieldDetail.label || fieldDetail.name || key
});

const FieldSelector = ({ field, onChange, command }) => {
  const intl = useIntl();
  const model = useSelector(selectJobModel);
  const target = useSelector(selectJobTarget);
  const taskTarget = useSelector(selectTaskTarget);
  const options = useSelector((state) => selectFields(state, target || taskTarget || model));
  const parsedCommand = command === 'update' ? 'replace' : command;
  const filteredOptions = Object.entries(options).filter((obj) => obj[1][parsedCommand]);

  if (isEmpty(options)) return null;
  return (
    <Wrapper>
      <Label>Field</Label>
      <StandardDropdown
        width="200px"
        field="action"
        options={ filteredOptions.map(([key, fieldDetail]) => {
          const label = getFieldLabel(intl, key, fieldDetail);
          return { desc: label, name: label, id: key };
        }) }
        updateValue={ (f, v) => onChange(v) }
        defaultValue={ field }
        selectObject
      />
    </Wrapper>
  );
};

FieldSelector.defaultProps = {
  field: '',
  command: ''
};

FieldSelector.propTypes = {
  field: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  command: PropTypes.string
};

export default FieldSelector;
